import { useEffect, useState } from "react";
import moment from "moment";
import TableWithSkeleton from "../../../../components/table/TableWithSkeleton";
import recentTransactionColumns from '../../../../columns/recentTransaction.jsx';
import MySegmented from "../../../../components/segmented/Segmented";

const RecentTableMobile = ({ data }) => {
    const [type, setType] = useState("Deposit");
    const [filteredData, setFilteredData] = useState([]);

    useEffect(() => {
        const transactionData = type === "Deposit" ? data?.lastfiveDeposit : data?.lastfiveWithdrawal;

        setFilteredData(transactionData?.map((item) => {
            return ({
                ...item,
                amount: `$ ${item?.amount}`,
                transactionDate: item?.transactionDate ? moment(item?.transactionDate).format('DD-MM-YYYY LT') : null,
                status: <span className={`px-3 py-1 rounded-full uppercase text-xs text-center ${item?.status === "Success" ? 'success_tag' : 'fail_tag'}`}>{item?.status}</span>,
            })
        }));
    }, [type, data]);

    return (
        <div className='bg-white rounded-2xl p-4'>
            <div className="items-center pb-4  justify-between mb-3 border-b border-gray-200">
                <h3 className="text-lg font-bold text-gray-600 mb-3">Recent Transactions</h3>
                <MySegmented options={["Deposit", "Withdraw"]} value={type} setValue={setType} block={true} />
            </div>
            <div className="bg-white rounded-lg overflow-hidden  pt-2">
                <TableWithSkeleton columns={recentTransactionColumns} data={filteredData} />
            </div>
        </div>
    )
}

export default RecentTableMobile;
